import React from "react";
import { Button, Card, Col, Form, Input, Row, Select, Alert, Radio, Spin } from "antd";
import api_url from '../../../utils/requestApi';
import ServerApi from '../../../utils/ServerApi';
import appConst from '../../../constents/app.const';


class SendCoin extends React.Component{
    constructor(props){
        super(props)
    }
    formRef = React.createRef()
    state={
        authFail: false,
        authFailMsg: 'Input correct data',
        authFailClub: false,
        authFailMsgClub: 'Input correct data',
        loadingmh: false,
        loading: false
    }
    componentDidMount(){
        // console.log(this.props.userData.info)
    }
    onReset = () => {
        this.formRef.current.resetFields()
    }
    onFinish = (e) => {
        const serverApi = new ServerApi(appConst.apiUrl, this.props.token);
        this.setState({loading: true}, () => {
          serverApi.account_actions(api_url.send_coin_usertouser, 'POST', e, returnData => {
              if(returnData.success == 1){
                  this.setState({
                      authFail: false,
                      authFailMsg: returnData.message,
                      loading: false
                  }, () => {
                      this.onReset();
                      this.props.onMyAccount();
                  })
              }else{
                  this.setState({
                      authFail: true,
                      authFailMsg: returnData.message,
                      loading: false
                  })
              }
          })
        })
    }
    onFinishClub = (e) => {
        const serverApi = new ServerApi(appConst.apiUrl, this.props.token)
        this.setState({loadingmh: true}, () => {
         serverApi.account_actions(api_url.send_coin_userto_club, 'POST', e, returnData => {
            if(returnData.success == 1){
                this.setState({
                    authFailClub: false,
                    authFailMsgClub: returnData.message,
                    loadingmh: false
                }, () => {
                    this.onReset();
                    this.props.onMyAccount();
                })
            }else{
                this.setState({
                    authFailClub: true,
                    authFailMsgClub: returnData.message,
                    loadingmh: false
                })
            }
          })
        })
    }
    render(){
        return(
            <div>
                <Row>
                    <Col xs={0} sm={0} md={0} lg={6} xl={6}></Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}
                        style={{background: 'white'}}
                    >
                        {/* <Card>
                            <u className="ml-5"><h5>Send Coin To User</h5></u>
                            {this.state.authFail ? <Alert message={this.state.authFailMsg} type="error" showIcon /> : 
                            <Alert message={this.state.authFailMsg} type="success" showIcon />}
                            <Spin spinning={this.state.loading} tip="Processing...">
                              <Form
                                  ref={this.formRef}
                                  onFinish={this.onFinish}
                              >
                                  <div className="pb-10">
                                      <label>From me</label>
                                      <Form.Item
                                          name="from_userId"
                                      >
                                          <Input type="text" defaultValue={this.props.userData.info.userId} disabled/>
                                      </Form.Item>
                                  </div>
                                  <div className="pb-10">
                                      <label>To UserId</label>
                                      <Form.Item
                                          name="to_userId"
                                          rules={[
                                          {
                                              required: true,
                                              message: 'Please input to userId',
                                          },
                                          ]}
                                      >
                                          <Input type="text" placeholder="to userId"/>
                                      </Form.Item>
                                  </div>
                                  <div className="pb-10">
                                      <label>Amount</label>
                                      <Form.Item
                                          name="amount"
                                          rules={[
                                          {
                                              required: true,
                                              message: 'Please input amount 100 to 30000',
                                          },
                                          ]}
                                      >
                                          <Input type="number" placeholder="amount" maxLength={5}/>
                                      </Form.Item>
                                  </div>
                                  <div className="pb-10">
                                      <label>Password</label>
                                      <Form.Item
                                          name="password"
                                          rules={[
                                          {
                                              required: true,
                                              message: 'Please input password',
                                          },
                                          ]}
                                      >
                                          <Input.Password type="password" placeholder="password"/>
                                      </Form.Item>
                                  </div>
                                  <div className="pb-10">
                                      <Form.Item>
                                          <Button type="primary" htmlType="submit" block>Submit</Button>
                                      </Form.Item>
                                  </div>
                              </Form>
                            </Spin>
                        </Card> */}
                        <Card>
                            <u className="ml-5"><h5>Send Coin To Money Holder</h5></u>
                            {this.state.authFailClub ? <Alert message={this.state.authFailMsgClub} type="error" showIcon /> : 
                            <Alert message={this.state.authFailMsgClub} type="success" showIcon />}
                            <Spin spinning={this.state.loadingmh} tip="Processing...">
                             <Form
                                 ref={this.formRef}
                                 onFinish={this.onFinishClub}
                             >
                                 <div className="pb-10">
                                     <label>From me</label>
                                     <Form.Item
                                         name="from_userId"
                                     >
                                         <Input type="text" defaultValue={this.props.userData.info.userId} disabled/>
                                     </Form.Item>
                                 </div>
                                 <div className="pb-10">
                                     <label>To Money Holder</label>
                                     <Form.Item
                                         name="to_mholder"
                                         rules={[
                                          {
                                              required: true,
                                              message: 'Please input money holder Id',
                                          },
                                          ]}
                                     >
                                         <Input type="text" placeholder="Money holder Id"/>
                                     </Form.Item>
                                 </div>
                                 <div className="pb-10">
                                     <label>Amount</label>
                                     <Form.Item
                                         name="amount"
                                         rules={[
                                         {
                                             required: true,
                                             message: 'Please input amount 100 to 20,000',
                                         },
                                         ]}
                                     >
                                         <Input type="number" placeholder="amount" maxLength={5}/>
                                     </Form.Item>
                                 </div>
                                 <div className="pb-10">
                                     <label>6 Digit Pin</label>
                                     <Form.Item
                                         name="password"
                                         rules={[
                                         {
                                             required: true,
                                             message: 'Please input 6 digit pin',
                                         },
                                         ]}
                                     >
                                         <Input.Password type="password" placeholder="6 Digit Pin"/>
                                     </Form.Item>
                                 </div>
                                 <div className="pb-10">
                                     <Form.Item>
                                         <Button type="primary" htmlType="submit" block>Submit</Button>
                                     </Form.Item>
                                 </div>
                             </Form>
                            </Spin>
                        </Card>
                    </Col>
                    <Col xs={0} sm={0} md={0} lg={6} xl={6}></Col>
                </Row>
            </div>
        )
    }
}

export default SendCoin;